import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-slider-toggle',
    templateUrl: './slider-toggle.component.html',
    styleUrls: ['./slider-toggle.component.scss'],
    imports: [
        CommonModule,
    ]
})
export class SliderToggleComponent {
  @Input() isChecked: boolean = false;
  @Input() dataTest: string = '';
  @Input() size: 'small' | 'medium' = 'medium';
  @Input() theme: 'default' | 'warning' = 'default';
  @Input() compact: boolean = false;

  @Output() onClickEM: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  onClick() {
    this.onClickEM.emit(this.isChecked);
  }

}
